import { render, staticRenderFns } from "./AccommodationExtraPrices.vue?vue&type=template&id=4a395230"
import script from "./AccommodationExtraPrices.vue?vue&type=script&lang=ts"
export * from "./AccommodationExtraPrices.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports